export default "/assets/site/images/kerekpar.jpg?0605751a2c35627f889c05d46d36bec7";